<mat-expansion-panel class="finding-details__panel" *ngIf="finding">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Finding Detail
    </mat-panel-title>
  </mat-expansion-panel-header>  

  <div class="finding-details__panel__values">
    <div class="finding-details__panel__values--id iaud-value-container">
      <label for="finding-id">Finding id:</label>
      <p id="finding-id">{{ finding.findingId }}</p>
    </div>

    <div class="finding-details__panel__values--title iaud-value-container">
      <label for="finding-title">Finding title:</label>
      <p id="finding-title">{{ finding.findingTitle }}</p>
    </div>

    <div class="finding-details__panel__values--code iaud-value-container">
      <label for="finding-code">Finding code:</label>
      <p id="finding-code">{{ finding.findingCode }}</p>
    </div>

    <div class="finding-details__panel__values--owner-group iaud-value-container">
      <label for="finding-owner-group">Deviation Owners:</label>
      <p id="finding-owners" *ngFor="let owner of finding.findingOwner">
        {{ owner.fullName }}
      </p>
    </div>

    <div class="finding-details__panel__values--description iaud-value-container description">
      <label for="finding-description">Finding description:</label>
      <p id="finding-description">{{ finding.findingDescription }}</p>
    </div>

    <div class="finding-details__panel__values--due-date iaud-value-container">
      <label for="finding-due-date">Evidence Approval Due Date</label>
      <p id="finding-due-date">{{ finding.dueDate | date:dateFormat }}</p>
    </div>

    <div class="finding-details__panel__values--status iaud-value-container">
      <label for="finding-status">finding status:</label>
      <p id="finding-status">{{ finding.status }}</p>
    </div>
  </div>
</mat-expansion-panel>